module.exports = __webpack_public_path__ + "img/发票.4d20b024.svg";